import BasketSummaryModelBase from '../_generated/modelBases/basket-summary-model-base';

export default class BasketSummaryModel extends BasketSummaryModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
